<template>
  <form class="form" method="post">

    <div id="appSpendingCreateVueComponent" class="appFontBlack">
      <HeaderApp />
      <div class="appGroupOfDivCreateOrModify">
        <h2>Ajouter une dépense</h2>
        <div class="appGroupOfDivNamesAndInput">
          <div class="appGroupOfDivNames">
            <p class="appLabelStyle1">Date débit*</p>
            <p class="appLabelStyle1">Catégorie*</p>
            <p class="appLabelStyle1">Fournisseur</p>
            <p class="appLabelStyle1">Référence</p>
            <p class="appLabelStyle1">Montant*</p>
            <p class="appLabelStyle1">Paiement*</p>
          </div>
          <div class="appGroupOfInput">
            <input v-model="date" type="date" name="date" class="appInputStyle1" placeholder="">
            <select v-model="category" type="select" name="category" class="appInputStyle1" placeholder="Catégorie">
              <option valeur="femme">Consommables</option>
              <option valeur="homme">Matériel</option>
              <option valeur="femme">Consommables + Matériel</option>
              <option valeur="homme">Assurance</option>
              <option valeur="femme">Essence</option>
              <option valeur="homme">Frais bancaires</option>
              <option valeur="homme">Salaire</option>
              <option valeur="homme">Téléphone</option>
              <option valeur="homme">URSSAF</option>
              <option valeur="homme">Autres</option>
            </select>
            <input v-model="supplier" type="string" name="supplier" class="appInputStyle1" placeholder="Fournisseur">
            <input v-model="reference" type="string" name="reference" class="appInputStyle1"
              placeholder="Numéro de facture">
            <input v-model="price" type="number" step='0.01' name="price" class="appInputStyle1" placeholder="">
            <select v-model="typeofpaiement" type="string" name="typeofpaiement" class="appInputStyle1" placeholder="">
              <option valeur="Espèces">Espèces</option>
              <option valeur="Chèque">Chèque</option>
              <option valeur="CB">CB</option>
              <option valeur="Virement">Virement</option>
            </select>
          </div>
        </div>
      </div>
      <button @click.prevent="createSpending()" type="submit" class="appButtonModel2">Ajouter ma dépense</button>
      <div v-show="errorMsg" class="error">{{ errorMsg }}</div>
    </div>

  </form>
</template>

<script>
// Désactiver le problème du camel case avec jwt-decode
// eslint-disable-next-line camelcase
import jwt_decode from 'jwt-decode'
import axios from 'axios'
import HeaderApp from '../Application/HeaderApp.vue'
export default {
  beforeCreate () {
    const tokenWithDatas = JSON.parse(localStorage.getItem('userPrivilegia'))
    if (!tokenWithDatas) { this.$router.push('/App/Login') }
  },
  components: {
    HeaderApp
  },
  name: 'SpendingCreate',
  data () {
    return {
      date: '',
      reference: '',
      supplier: '',
      category: '',
      price: '',
      typeofpaiement: '',
      errorMsg: ''
    }
  },
  methods: {
    createSpending () {
      if (this.reference === '') { this.reference = ' ' }
      if (this.supplier === '') { this.supplier = ' ' }
      if (this.date !== null || this.category !== null || this.price !== null || this.typeofpaiement !== null) {
        this.errorMsg = ''
        // Si champs tous remplis -Récupérer les données du localStorage
        const tokenWithDatas = JSON.parse(localStorage.getItem('userPrivilegia'))
        const decryptedToken = jwt_decode(tokenWithDatas.token)
        axios
          .post('https://privilegia.fr/api/depenses', {
            userId: decryptedToken.userId,
            date: this.date,
            reference: this.reference,
            supplier: this.supplier,
            category: this.category,
            price: this.price,
            typeofpaiement: this.typeofpaiement
          }, {headers: { Authorization: 'Bearer ' + tokenWithDatas.token, 'Content-Type': 'application/json' }})
          .then((response) => {
            window.alert('Nouvelle dépense ajoutée')
            this.$router.push('/App/Spendings')
          })
          .catch((error) => {
            this.errorMsg = 'Merci de renseigner tous les champs'
            console.log(error.response.data)
          })
      } else {
        this.errorMsg = 'Merci de renseigner tous les champs'
      }
    }}}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/Application/AppSpendingsCreate.vue